export default __webpack_public_path__ + "static/media/close.427f7e86.svg";